module.exports = __webpack_public_path__ + "img/logo-topleft.9b1cc5a9.svg";